/**
 * Flat site navigation — no dropdowns.
 * Each top-level item maps to a single consolidated page.
 *
 * Owner directive (Feb 18, 2026): order tightened to put product story
 * first. Seven items:
 *   About Us · Services · Testimonials · What's New · Roadmap ·
 *   Corporate Profile · Contact
 * Customers + Approach + Careers + Ecosystem are NOT exposed
 * as top-level nav; their content lives inside About Us, and old URLs
 * redirect cleanly via App.jsx.
 */
export const SITE_NAV = [
  {
    key: "about",
    path: "/about",
    accent: "#5B2E83",
    children: [
      { key: "aboutUs", path: "/about", labelEn: "About Us", labelJa: "会社情報" },
      { key: "leadership", path: "/our-leaders", labelEn: "Leadership Team", labelJa: "リーダーシップ" },
      { key: "ourTeam", path: "/our-team", labelEn: "Our AI Team", labelJa: "AIチーム" },
      { key: "signboards", path: "/signboards", labelEn: "Signboards", labelJa: "看板掲出" },
    ],
  },
  { key: "services", path: "/services", accent: "#0E5FB0" },
  { key: "testimonials", path: "/testimonials", accent: "#5B2E83" },
  { key: "whatsNew", path: "/whats-new", accent: "#2F8F3C" },
  { key: "roadmap", path: "/roadmap", accent: "#0E5FB0" },
  { key: "corporateProfile", path: "/corporate-profile", accent: "#0F1D2D" },
  { key: "contact", path: "/contact", accent: "#0E5FB0" },
];

export const SERVICE_BRANDS = [
  { slug: "japanetccard", domain: "japanetccard.com", accent: "purple", accentHex: "#5B2E83" },
  { slug: "japantollreceipts", domain: "japantollreceipts.jp", accent: "green", accentHex: "#2F8F3C" },
  { slug: "japanchangemoney", domain: "japanchangemoney.com", accent: "blue", accentHex: "#0E5FB0" },
];

export const BUSINESS_PILLARS = [
  { key: "pillarMobility", accent: "purple", accentHex: "#5B2E83" },
  { key: "pillarRecords", accent: "green", accentHex: "#2F8F3C" },
  { key: "pillarFinancial", accent: "blue", accentHex: "#0E5FB0" },
  { key: "pillarMultilingual", accent: "navy", accentHex: "#0F1D2D" },
];

export const HOME_TRUST_STRIP = [
  { key: "trustFounded" },
  { key: "trustYokosuka" },
  { key: "trustBilingual" },
  { key: "trustServices" },
  { key: "trustOperational" },
];
